import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const SubFuncTitle = styled.div`
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    text-align: center;
  }
`;

export const SubFuncPage = styled.div`
  padding: 64px 0;
  background-color: #f7f7f7;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 64px 0;
  }
`;

export const SubFuncSection = styled.div<{ columns?: number }>`
  margin-top: 32px;
  display: grid;
  grid-template-columns: repeat(${({ columns = 4 }) => columns}, 1fr);
  grid-gap: ${({ columns = 4 }) => (columns === 5 ? '16px' : '32px')};
  grid-auto-rows: 1fr;

  @media (max-width: 1000px) {
    ${({ columns = 4 }) =>
      columns === 5 &&
      `
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
    `}
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-padding: 0 16px;
    gap: 16px;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const SubFuncBox = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
  border-radius: 12px;
  padding: 48px 24px;
  flex: 1 0 0;
  height: 100%;
  background-color: #fff;

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 50px 16px;
    scroll-snap-align: center;
    min-width: 200px;
    min-height: 200px;

    flex: 0 0 auto;
  }
`;

export const SubFuncIcon = styled.img`
  width: 28px;
  height: 28px;
  object-fit: contain;
`;

export const IndicatorContainer = styled.div<{ alignStart?: boolean }>`
  display: flex;
  justify-content: ${({ alignStart }) => (alignStart ? 'start' : 'center;')};
  padding: 32px 0;
  gap: 8px;
`;

export const IndicatorDot = styled.div<{ active: boolean }>`
  width: 24px;
  height: 4px;
  border-radius: 4px;
  background-color: ${({ active }) => (active ? '#000' : 'rgba(0, 0, 0, 0.08)')};
  transition: background-color 0.3s;
`;
